import { useCallback, useState } from 'react';
import { downloadContent } from '../../api/contents';
import './ImageCard.css';

function ImageCard({ src, alt, contentId, downloadName }) {
  const fileName = downloadName || alt || 'inmotion-photo';
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = useCallback(
    async (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (isDownloading || contentId == null) {
        return;
      }

      setIsDownloading(true);

      try {
        await downloadContent(contentId, fileName);
      } catch {
        // Download failed silently.
      } finally {
        setIsDownloading(false);
      }
    },
    [contentId, fileName, isDownloading]
  );

  return (
    <article className="image-card">
      <img
        className="image-card__img"
        src={src}
        alt={alt}
        loading="lazy"
      />
      <button
        type="button"
        className="image-card__download"
        onClick={handleDownload}
        disabled={isDownloading || contentId == null}
        aria-label={`Download ${alt}`}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          aria-hidden="true"
        >
          <path
            d="M8 2v8m0 0L5 7m3 3 3-3M3 12.5v1a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </article>
  );
}

export default ImageCard;
